module.exports = __webpack_public_path__ + "img/tester_03.79a4eeb4.jpg";